/**
 * Main App Component
 *
 * Handles routing and global layout.
 */

import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/Home';
import { SearchPage } from './pages/Search';
import { LibraryPage } from './pages/Library';
import { AlbumPage } from './pages/Album';
import { ArtistPage } from './pages/Artist';
import { PlaylistPage } from './pages/Playlist';
import { SettingsPage } from './pages/Settings';
import { WhitelistArtistsPage } from './pages/WhitelistArtists';
import { LikedSongsPage } from './pages/LikedSongs';
import { YouTubeLoginPage } from './pages/YouTubeLogin';
import { useWhitelistStore } from './stores/whitelist';

export default function App() {
  const { syncWhitelist } = useWhitelistStore();

  // Sync whitelist on app load
  useEffect(() => {
    syncWhitelist();
  }, [syncWhitelist]);

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="library" element={<LibraryPage />} />
        <Route path="liked" element={<LikedSongsPage />} />
        <Route path="album/:id" element={<AlbumPage />} />
        <Route path="artist/:id" element={<ArtistPage />} />
        <Route path="playlist/:id" element={<PlaylistPage />} />
        <Route path="artists" element={<WhitelistArtistsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="settings/youtube-login" element={<YouTubeLoginPage />} />
      </Route>
    </Routes>
  );
}
